export default "__VITE_ASSET__BkFE41$f__"